module.exports = __webpack_public_path__ + "img/dialog-notice-en.6f488f3a.png";